import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, delay, retry, tap, throwError, timer } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OptionalHeaders } from '../modules/auth/services/auth-http/auth-http.service';

export const PAGE = 0;
export const MAX_RESULTS = 25;
export interface QueryFilter {
    field: string;
    type?: string;
    value?: any;
    filterable?: boolean;
    role?: string;
    placeholder?: string;
    options?: QueryFilterOption[];    
    data?: {
        path: string;
        property: string;
        value: string;
        label: string;
        options?: any[];
        order?: {
            field: string;
            direction: string;
        };
    }
}

export interface QueryFilterOption {
    value: string;
    label: string;
}

@Injectable({
  providedIn: 'root'
})
export class DataService {

    constructor(private http: HttpClient) { }

    load(path: string, filters: QueryFilter[] = []): Observable<any> {        
        let params = '';
        if(filters.length) {                
            filters.filter(e => e.value).forEach(filter => {
                if(params) {
                    params += '&' + filter.field + '=' + filter.value
                }
                else {
                    params += '?' + filter.field + '=' + filter.value
                }                    
            });
        }
        return this.http.get<any>(environment.apiUrl + path + params);         
    }

    list(path: string, filters: QueryFilter[] = []): Observable<any> {            
        let params = '';
        if(filters.length) {                
            filters.filter(e => e.value !== undefined && e.value !== '').forEach(filter => {
                if(params) {
                    params += '&' + filter.field + '=' + filter.value
                }
                else {
                    params += '?' + filter.field + '=' + filter.value
                }                    
            });
        }
        return this.http.get<any>(environment.apiUrl + `${path}` + params); 
    }

    post<T>(path: string, entity?: T, observeResponse?: boolean): Observable<any> {        
        if(observeResponse) {
            return this.http.post<T>(environment.apiUrl + path, entity, { observe: 'response' });
        }
        else {
            return this.http.post<T>(environment.apiUrl + path, entity);
        }        
    }

    put<T>(path: string, entity?: T): Observable<any> {        
        return this.http.put<T>(environment.apiUrl + path, entity);
    }

    patch<T>(path: string, entity?: T): Observable<any> {
        return this.http.patch<T>(environment.apiUrl + path, entity);
    }

    get(path: string, responseType?: string): Observable<any> {    
        const headers = this.getCustomHeaders([], responseType);  
        return this.http.get<any>(environment.apiUrl + path, headers);
    }

    retryGet(path: string, responseType?: string, config?: requestConfig, api?: APIVersion): Observable<any> {        
        const headers = this.getCustomHeaders([], responseType);   
        let endpoint = environment.apiUrl;
        if(api == APIVersion.PREPROCESSED) {
            endpoint = environment.preprocessedUrl;              
        }            
        return this.http.get<any>(endpoint + path, headers).pipe(           
            tap(() => console.log(`GET success`, path)),
            retry({count: config?.count || 5, delay: (error, retryIndex) => {
                    let retry: any = throwError(() => error);                        
                    if (error.status === 0 || error.status === 429 || error.status === 500) {
                        console.log(`GET Error ${error.status}. Retry number ${retryIndex}:`, path)
                        retry = timer(2000);
                    }
                    else {
                        console.log(`GET Error ${error.status}. Not retry:`, path)
                    }
                    return retry;
                }
            }),
            delay(config?.delay || 0)
        );       
    }

    delete(path: string): Observable<any> {         
        return this.http.request('delete', environment.apiUrl + path);
    }

    getCustomHeaders(optHeaders?: OptionalHeaders[], responseType?: string): {} {
        let headers;
        if(optHeaders?.length) {
            let customHeaders = {
            };  
            optHeaders.forEach(h => {
                (customHeaders as any)[h.name] = h.value;
            }); 
            headers = new HttpHeaders(customHeaders);
        }
        else {
            headers = new HttpHeaders({});  
        }         
        return {headers, responseType};
    }
}

export interface requestConfig {
    count?: number,
    delay?: number
}

export enum APIVersion {
    BACKEND = 0,
    PREPROCESSED = 1
}

